import { type DetailAdjuntoComunicadoModel, type DetailComunicadoModel, TipoComunicadoEnum } from "@api/api";

export const TIPO_EMPRESA_AGENTE_TODAS = "";

export class ComunicadoModel {
  Id?: string;
  Tipo: TipoComunicadoEnum = TipoComunicadoEnum.Mail;
  TipoEmpresaAgenteDirigido: string = TIPO_EMPRESA_AGENTE_TODAS;
  RolesDirigidos: string[] = [];
  EmpresasAgentesDirigidos: string[] = [];
  Asunto: string = "";
  Cuerpo: string = "";
  adjuntosIniciales: DetailAdjuntoComunicadoModel[] = [];

  constructor(data?: Partial<ComunicadoModel>) {
    Object.assign(this, data);
  }

  static fromDetail(detail: DetailComunicadoModel): ComunicadoModel {
    return new ComunicadoModel({
      Id: detail.Id,
      Tipo: detail.Tipo,
      TipoEmpresaAgenteDirigido: detail.TipoEmpresaAgenteDirigido ?? TIPO_EMPRESA_AGENTE_TODAS,
      RolesDirigidos: detail.RolesDirigidos.map((rol) => rol.Id) ?? [],
      EmpresasAgentesDirigidos: detail.EmpresasAgentesDirigidos.map((empresa) => empresa.Id) ?? [],
      Asunto: detail.Asunto,
      Cuerpo: detail.Cuerpo,
      adjuntosIniciales: detail.Adjuntos ?? [],
    });
  }

  toCreateApiArgs(adjuntos?: File[]) {
    return [
      this.Tipo,
      this.Asunto,
      this.Cuerpo,
      this.TipoEmpresaAgenteDirigido || undefined,
      this.RolesDirigidos,
      this.EmpresasAgentesDirigidos,
      adjuntos?.length ? adjuntos : undefined,
    ] as const;
  }

  toEditApiArgs(idsAdjuntosExistentes: string[], adjuntos?: File[]) {
    const [tipo, asunto, cuerpo, tipoEmpresa, roles, empresas, adjuntosNuevos] = this.toCreateApiArgs(adjuntos);

    return [
      this.Id,
      idsAdjuntosExistentes.length ? idsAdjuntosExistentes : undefined,
      tipo,
      asunto,
      cuerpo,
      tipoEmpresa,
      roles,
      empresas,
      adjuntosNuevos,
    ] as const;
  }
}
